export default {
  install(Vue) {
    // Define the custom directive
    Vue.directive("uppercase", {
      // bind hook is called only once, when the directive is first bound to the element.
      bind(el, binding) {
        // Use the textContent property to set the element's text to uppercase
        el.textContent = el.textContent.toUpperCase();
      },

      // update hook is called whenever the element updates
      update(el, binding) {
        // Update the text content to uppercase when the element updates
        el.textContent = el.textContent.toUpperCase();
      },
    });
  },
};
